import React, { useState, useEffect, useRef } from 'react';
import { $t } from '@/modules/i18n';
import { Button } from 'shopee-ui-react';
import { getMeta } from '@/modules/request';
import SubscribeModal from './SubscribeModal';
import SubscribePopup from './SubscribePopup';
import '@/assets/scss/components/subscribe.scss';
import 'shopee-ui-react/es/theme-default/components/button/index.css';
/**
 * mobile端popup需要通过css设置popup的高度，不同microsite导航栏高度可能会不一致
 */

export default () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [popupVisible, setPopupVisible] = useState(false);
  const [locationList, setlocationList] = useState([]);
  const [levelList, setLevelList] = useState([]);
  const [deptList, setDeptList] = useState([]);

  useEffect(() => {
    getMeta().then(res => {
      const { locationList, levelList, deptList } = res;
      setlocationList(locationList);
      setLevelList(levelList);
      setDeptList(deptList);
    }).catch(err => {
      console.error(err);
    });
  }, []);

  const subscribeShow = () => {
    if(document.body.clientWidth > 991) {
      setModalVisible(true);
    } else {
      setPopupVisible(true);
    }
  }

  return (
    <>
      <div className="subscribe-button-container">
        <Button className="subscribe-button" size="large" type="primary" outline onClick={subscribeShow}>{$t('microsite_footer_btn_subscribe_text')}</Button>
      </div>
      <SubscribeModal 
        locationList={locationList}
        levelList={levelList}
        deptList={deptList}
        setModalVisible={setModalVisible} 
        visible={modalVisible}/>

      <SubscribePopup 
        locationList={locationList}
        levelList={levelList}
        deptList={deptList}
        visible={popupVisible} 
        setVisible={setPopupVisible} />
    </>
  )
}